/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FEATURE_FLAG = "ALTERNATE_OLDEST_FIRST_VIEW" | "AVATARS" | "COMMENT_SEEN" | "CONFIGURE_PUBLIC_PROFILE_URL" | "COUNTS_V2" | "DATA_CACHE" | "DEFAULT_QA_STORY_MODE" | "DISABLE_LIVE_UPDATES" | "DISABLE_WARN_USER_OF_TOXIC_COMMENT" | "DISCUSSIONS" | "EMAIL_META" | "ENABLE_QA" | "ENABLE_RATINGS_AND_REVIEWS" | "EXTERNAL_MEDIA" | "NEW_COMMENT_COUNT" | "READ_MORE_NEW_TAB" | "REDUCED_SECURITY_MODE" | "RTE_SARCASM" | "SECTIONS" | "VIEWER_COUNT" | "Z_KEY" | "%future added value";
export type FeaturedCommentsContainer_settings = {
    readonly reaction: {
        readonly sortLabel: string;
    };
    readonly featureFlags: ReadonlyArray<FEATURE_FLAG>;
    readonly disableCommenting: {
        readonly enabled: boolean;
    };
    readonly " $fragmentRefs": FragmentRefs<"FeaturedCommentContainer_settings" | "ViewersWatchingContainer_settings" | "PostCommentFormContainer_settings">;
    readonly " $refType": "FeaturedCommentsContainer_settings";
};
export type FeaturedCommentsContainer_settings$data = FeaturedCommentsContainer_settings;
export type FeaturedCommentsContainer_settings$key = {
    readonly " $data"?: FeaturedCommentsContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"FeaturedCommentsContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FeaturedCommentsContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ReactionConfiguration",
            "kind": "LinkedField",
            "name": "reaction",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sortLabel",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "featureFlags",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "DisableCommenting",
            "kind": "LinkedField",
            "name": "disableCommenting",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FeaturedCommentContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ViewersWatchingContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PostCommentFormContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '33fcfff4c114b369d7219b59680f7766';
export default node;
